import { twMerge } from 'tailwind-merge'

export type BadgeProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & {
  size?: 'sm' | 'lg' | 'md'
  color?: 'gray' | 'red' | 'rust' | 'yellow' | 'green' | 'blue' | 'indigo' | 'purple' | 'pink' | 'white'
  rounded?: boolean
}

export function Badge({ size = 'sm', color = 'gray', rounded = false, ...props }: BadgeProps) {
  return (
    <span
      {...props}
      className={twMerge(
        'inline-flex items-center font-medium whitespace-nowrap',
        size === 'sm' && 'px-2.5 py-0.5 text-xs rounded-sm',
        size === 'lg' && 'px-3 py-0.5 text-sm rounded-md',
        size === 'md' && 'px-2 py-0.5 text-xs font-normal rounded-md',
        rounded && 'rounded-full',
        color === 'gray' && 'bg-gray-100 text-gray-800',
        color === 'white' && 'bg-white text-gray-800',
        color === 'red' && 'bg-red-100 text-red-800',
        color === 'yellow' && 'bg-yellow-100 text-yellow-800',
        color === 'green' && 'bg-green-100 text-green-800',
        color === 'blue' && 'bg-blue-100 text-blue-800',
        color === 'indigo' && 'bg-indigo-100 text-indigo-800',
        color === 'purple' && 'bg-purple-100 text-purple-800',
        color === 'pink' && 'bg-pink-100 text-pink-800',
        color === 'rust' && 'bg-rust-500/10 text-rust-500',
        props.className
      )}
    />
  )
}
